import React, { PureComponent, Fragment } from 'react'
import { formatPrice } from 'helpers'
import moment from 'moment'
import cx from 'classnames'
import { connect } from 'redaction'

import { Grid, Cell } from 'components/layout/grid'
import Button from 'components/ui/Button/Button'
import Box from 'components/layout/Box/Box'

import s from './FullToolsReport.scss'


class FullToolsReport extends PureComponent {

  state = {
    node: null,
  }

  componentDidMount() {
    const encodedUri  = this.getEncodeUri()
    const link        = document.createElement('a')

    link.setAttribute('href', encodedUri)
    link.setAttribute('download', `${this.getTitle()}.csv`)

    document.body.appendChild(link)

    this.setState({ node: link })
  }

  componentWillUnmount() {
    const { node } = this.state

    document.body.removeChild(node)
  }

  getTitle = () => {
    const { from, to, paymentType } = this.props

    const date = `с ${moment(from, 'DDMMYYYY').format('DD.MM.YYYY')} по ${moment(to, 'DDMMYYYY').format('DD.MM.YYYY')}`

    return `Справка о полученной выручке с портала умныйсаров.рф ${date}`
  }

  getTotals = ({ total, learnTotal, schedTotal, subscrTotal, name = 'все объекты' }) => {
    const result = []

    if (learnTotal) {
      result.push([
        'Итого (обучение):',
        '',
        learnTotal / 100
      ])
    }

    if (subscrTotal) {
      result.push([
        'Итого (абонементы):',
        '',
        subscrTotal / 100
      ])
    }

    if (schedTotal) {
      result.push([
        'Итого (разовые посещения):',
        '',
        schedTotal / 100
      ])
    }

    if (total) {
      result.push([
        `Итого ${name}:`,
        '',
        total / 100
      ])
    }

    return result
  }

  getEncodeUri = () => {
    const { statistic: { total, learnTotal, subscrTotal, schedTotal, tools }, toolName } = this.props

    let encodeData = 'data:text/csv;charset=utf-8,\uFEFF'

    const rows = []

    rows.push([ toolName ])
    rows.push([])

    rows.push([ this.getTitle() ])
    rows.push([])

    rows.push([
      'Номер заказа', 'Проверочный код', 'Сумма (руб.)', 'Тип заказа', 'Статус платежа', 'Дата платежа', 'Дата возврата',
      'Дата частичного возврата', 'Сумма частичного возврата', 'Тариф', 'ФИО', 'Сеансы',
    ])

    tools.forEach(({ total, learnTotal, schedTotal, subscrTotal, tool: { id, name }, subscriptions = [] }) => {

      rows.push([])
      rows.push([])
      rows.push([ name ])

      subscriptions.forEach(({ active, id, subscriber, learnGroup, transaction, canceledAt, tariff, ts, voucher, quota, trainer, tariffCategory, usages = [] }, index) => {
        const { acquireReqStatus, amount, status, partRefundAt, partRefundAmount } = transaction
        const { birth, gender, label } = subscriber
        const { firstName, lastName, middleName } = trainer || {}
        const { name: tariffName } = tariffCategory || {}
        const { tariff: { description: learnGroupTariffName } = {} } = learnGroup || {}
        const { description: tariffDescriptionName } = tariff || {}

        const fio         = Boolean(subscriber.firstName) && `${subscriber.lastName} ${subscriber.firstName} ${subscriber.middleName}`

        const prevType    = index && ((subscriptions[index - 1].tariffCategory || {}).type || {}).type
        const tariffType  = tariffCategory.type && tariffCategory.type.type

        const isSchedule  = tariffType === 'SCHEDULE'
        const wasSchedule = index && prevType === 'SCHEDULE'

        const isTicket    = tariffType === 'SUBSCRIPTION'
        const wasTicket   = index && prevType === 'SUBSCRIPTION'

        const isLearn     = tariffType === 'LEARN'
        const wasLearn    = index && prevType === 'LEARN'

        let type = ''

        if (isSchedule) {
          if (!wasSchedule) {
            rows.push([ 'Разовые посещения' ])
          }

          type = 'Разовое посещение'
        }
        if (isTicket) {
          if (!wasTicket) {
            rows.push([ 'Абонементы' ])
          }

          type = `Абонемент (${quota})`
        }
        if (isLearn) {
          if (!wasLearn) {
            rows.push([ 'Обучение' ])
          }

          type = 'Обучение'
        }

        rows.push([
          id, voucher, Number(amount) / 100, type, status,
          `${moment(ts).format('DD.MM.YYYY')} ${moment(ts).format('HH:mm')}`,
          Boolean(canceledAt) ? `${moment(canceledAt).format('DD.MM.YYYY')} ${moment(canceledAt).format('HH:mm')}` : '',
          Boolean(partRefundAt) ? `${moment(partRefundAt).format('DD.MM.YYYY')} ${moment(partRefundAt).format('HH:mm')}` : '',
          partRefundAmount ? formatPrice(partRefundAmount, true, true) : 0,
          (tariffDescriptionName || learnGroupTariffName || tariffName || '').replace(/"/g, '\'').replace(/;/g, ''),
          fio || '',
          usages.map(({ id, schedule = {}, payed, services }, index) => {
            const session       = schedule.pattern && schedule.pattern.session || {}
            const sessionFromTo = `${session.start} - ${session.finish}`
            const date          = moment(schedule.day, 'YYYY-MM-DD').format('DD.MM.YYYY')

            return `- ${date} ${sessionFromTo} ${formatPrice(payed)}     
              ;;;;;;;;;;;${
                services.map(({ id, payed, title, quantity, price, relatedService }) => (
                  `- ${title}: ${formatPrice(payed)} (${quantity} шт.)`
                )).join('\n;;;;;;;;;;;')
              }
            `
          }).join(';;;;;;;;;;;')
        ])
      })

      rows.push([])
      rows.push(
        ...this.getTotals({ total, learnTotal, subscrTotal, schedTotal, name })
      )
    })

    rows.push([])
    rows.push([])

    rows.push(
      ...this.getTotals({ total, learnTotal, subscrTotal, schedTotal })
    )

    rows.push([])
    rows.push([])
    rows.push([])
    rows.push([])

    rows.push([
      'Источник',
      'https://умныйсаров.рф/marketplace/admin/report',
    ])

    return `${encodeData}${
      rows.map((items) => (
        items.map((item) => String(item || '')).join(';')
      ))
        .join('\n')
      }`
  }

  handleButtonClick = () => {
    const { node } = this.state
    const { onClose } = this.props

    node.click()
    onClose()
  }

  renderTotals = ({ total, learnTotal, schedTotal, subscrTotal, name = 'все объекты' }) => (
    <Grid columns={1} gutter="md">
      {
        Boolean(learnTotal) && (
          <Cell size={1}><b>Итого (обучение): {formatPrice(learnTotal, true, true)}</b></Cell>
        )
      }
      {
        Boolean(subscrTotal) && (
          <Cell size={1}><b>Итого (абонементы): {formatPrice(subscrTotal, true, true)}</b></Cell>
        )
      }
      {
        Boolean(schedTotal) && (
          <Cell size={1}><b>Итого (разовые посещения): {formatPrice(schedTotal, true, true)}</b></Cell>
        )
      }
      {
        Boolean(total) && (
          <Cell className={s.red} size={1}><b>Итого {name}: {formatPrice(total, true, true)}</b></Cell>
        )
      }
    </Grid>
  )

  render() {
    const {
      className, titleClassName, buttonClassName, darkClassName, darkestClassName,
      statistic: { total, learnTotal, schedTotal, subscrTotal, tools }, isEmpty,
      toolName,
    } = this.props

    return (
      <div className={className}>
        <Box pb="md">
          <div className={titleClassName}>{toolName}</div>
        </Box>
        <Box pb="md">
          <div className={titleClassName}>{this.getTitle()}</div>
        </Box>
        {
          isEmpty ? (
            <div>Нет статистики по выбранным условиям</div>
          ) : (
            <Fragment>
              {
                tools.map(({ total, learnTotal, schedTotal, subscrTotal, tool: { id, name }, subscriptions = [] }) => (
                  <Box key={id} pb="24">
                    <div>{name}</div>
                    {
                      Boolean(subscriptions.length) && (
                        <Box pt="16" pb="16">
                          {
                            subscriptions.map((data, index) => {
                              const { active, id, subscriber, learnGroup, transaction, ts, voucher, quota, trainer, canceledAt, tariff, tariffCategory, usages = [] } = data
                              const { acquireReqStatus, amount, status, partRefundAt, partRefundAmount  } = transaction
                              const { birth, gender, label } = subscriber
                              const { firstName, lastName, middleName } = trainer || {}
                              const { name: tariffName } = tariffCategory || {}
                              const { tariff: { description: learnGroupTariffName } = {} } = learnGroup || {}
                              const { description: tariffDescriptionName } = tariff || {}

                              const fio         = Boolean(subscriber.firstName) && `${subscriber.lastName} ${subscriber.firstName} ${subscriber.middleName}`
                              const prevType    = index && ((subscriptions[index - 1].tariffCategory || {}).type || {}).type
                              const tariffType  = tariffCategory.type && tariffCategory.type.type

                              const isSchedule  = tariffType === 'SCHEDULE'
                              const wasSchedule = index && prevType === 'SCHEDULE'

                              const isTicket    = tariffType === 'SUBSCRIPTION'
                              const wasTicket   = index && prevType === 'SUBSCRIPTION'

                              const isLearn     = tariffType === 'LEARN'
                              const wasLearn    = index && prevType === 'LEARN'

                              let addColumn     = 0

                              if (status) {
                                addColumn += 1
                              }
                              if (isTicket) {
                                addColumn += 1
                              }
                              if (isSchedule) {
                                addColumn += 2
                              }

                              const displayTitles = (
                                !index
                                || (isSchedule && !wasSchedule)
                                || (isTicket && !wasTicket)
                                || (isLearn && !wasLearn)
                              )

                              return (
                                <Fragment key={index}>
                                  {
                                    Boolean(isSchedule && !wasSchedule) && (
                                      <Grid className={darkestClassName} columns={1} gutter="md">
                                        <Cell size={1}>
                                          Разовые посещения
                                        </Cell>
                                      </Grid>
                                    )
                                  }
                                  {
                                    Boolean(isTicket && !wasTicket) && (
                                      <Grid className={darkestClassName} columns={1} gutter="md">
                                        <Cell size={1}>
                                          Абонементы
                                        </Cell>
                                      </Grid>
                                    )
                                  }
                                  {
                                    Boolean(isLearn && !wasLearn) && (
                                      <Grid className={darkestClassName} columns={1} gutter="md">
                                        <Cell size={1}>
                                          Обучение
                                        </Cell>
                                      </Grid>
                                    )
                                  }
                                  {
                                    displayTitles && (
                                      <Grid className={darkClassName} columns={9 + addColumn} gutter="md">
                                        <Cell size={1}>
                                          Номер заказа
                                        </Cell>
                                        <Cell size={1}>
                                          Проверочный код
                                        </Cell>
                                        <Cell size={1}>
                                          Сумма
                                        </Cell>
                                        <Cell size={1}>
                                          Тип заказа
                                        </Cell>
                                        {
                                          Boolean(status) && (
                                            <Cell size={1}>
                                              Статус платежа
                                            </Cell>
                                          )
                                        }
                                        <Cell size={1}>
                                          Дата платежа
                                        </Cell>
                                        <Cell size={1}>
                                          Дата возврата
                                        </Cell>
                                        <Cell size={1}>
                                          Дата частичного возврата
                                        </Cell>
                                        <Cell size={1}>
                                          Сумма частичного возврата
                                        </Cell>
                                        <Cell size={1}>
                                          Тариф
                                        </Cell>
                                        {
                                          Boolean(isTicket) && (
                                            <Cell size={1}>
                                              ФИО
                                            </Cell>
                                          )
                                        }
                                        {
                                          Boolean(isSchedule) && (
                                            <Cell size={2}>
                                              Сеансы
                                            </Cell>
                                          )
                                        }
                                      </Grid>
                                    )
                                  }
                                  <Grid
                                    className={cx({
                                      [darkClassName]: index % 2 !== 0,
                                    })}
                                    columns={9 + addColumn}
                                    gutter="md"
                                  >
                                    <Cell size={1}>
                                      {id}
                                    </Cell>
                                    <Cell size={1}>
                                      {voucher}
                                    </Cell>
                                    <Cell size={1}>
                                      {formatPrice(amount, true, true)}
                                    </Cell>
                                    <Cell size={1}>
                                      {
                                        isSchedule && (
                                          <div>Разовое посещение</div>
                                        )
                                      }
                                      {
                                        isTicket && (
                                          <div>Абонемент ({quota})</div>
                                        )
                                      }
                                      {
                                        isLearn && (
                                          <div>Обучение</div>
                                        )
                                      }
                                    </Cell>
                                    {
                                      Boolean(status) && (
                                        <Cell size={1}>
                                          {status}
                                        </Cell>
                                      )
                                    }
                                    <Cell size={1}>
                                      {moment(ts).format('DD.MM.YYYY')} {moment(ts).format('HH:mm')}
                                    </Cell>
                                    {
                                      Boolean(canceledAt) ? (
                                        <Cell size={1}>
                                          {moment(canceledAt).format('DD.MM.YYYY')} {moment(canceledAt).format('HH:mm')}
                                        </Cell>
                                      ) : (
                                        <Cell size={1} />
                                      )
                                    }
                                    <Cell size={1}>
                                      {
                                        Boolean(partRefundAt)
                                          ? `${moment(partRefundAt).format('DD.MM.YYYY')} ${moment(partRefundAt).format('HH:mm')}`
                                          : ''
                                      }
                                    </Cell>
                                    <Cell size={1}>
                                      {
                                        Boolean(partRefundAmount)
                                          ? formatPrice(partRefundAmount, true, true)
                                          : '0'
                                      }
                                    </Cell>
                                    <Cell size={1}>
                                      <span dangerouslySetInnerHTML={{ __html: tariffDescriptionName || learnGroupTariffName || tariffName || '' }} />
                                    </Cell>
                                    {
                                      Boolean(isTicket) && (
                                        <Cell size={1}>
                                          {fio}
                                        </Cell>
                                      )
                                    }
                                    {
                                      Boolean(isSchedule) && (
                                        <Cell size={2}>
                                          {
                                            usages.map(({ id, schedule = {}, payed, services }, index) => {
                                              const session       = schedule.pattern && schedule.pattern.session || {}
                                              const sessionFromTo = `${session.start} - ${session.finish}`
                                              const date          = moment(schedule.day, 'YYYY-MM-DD').format('DD.MM.YYYY')

                                              return (
                                                <Box key={id} pt={Boolean(!index) && '8'}>
                                                  <div className={s.nowrap}>
                                                    - {date} {sessionFromTo} {formatPrice(payed)}
                                                  </div>
                                                  {
                                                    services.map(({ id, payed, title, quantity, price, relatedService }) => (
                                                      <Box key={id} className={s.nowrap} pl="16">
                                                        - {title}: {formatPrice(payed)} ({quantity} шт.)
                                                      </Box>
                                                    ))
                                                  }
                                                </Box>
                                              )
                                            })
                                          }
                                        </Cell>
                                      )
                                    }
                                  </Grid>
                                </Fragment>
                              )
                            })
                          }
                        </Box>
                      )
                    }
                    {
                      Boolean(total || learnTotal || schedTotal || subscrTotal)
                        ? this.renderTotals({ total, learnTotal, schedTotal, subscrTotal, name })
                        : '-'
                    }
                  </Box>
                ))
              }
              <hr />
              <Box pt="24">
                {this.renderTotals({ total, learnTotal, schedTotal, subscrTotal })}
              </Box>
              <Box pt="24">
                <Button
                  className={buttonClassName}
                  title="Сохранить в файл"
                  green
                  onClick={this.handleButtonClick}
                />
              </Box>
            </Fragment>
          )
        }
      </div>
    )
  }
}


export default connect({
  toolName: (state) => {
    const { marketplace: { layersNavigation: { category, tools, toolType, tool, area, nomenclature } } } = state

    if (category === 'sport') {
      const selectedTool = tools.find(({ id }) => id === toolType)

      if (selectedTool) {
        const toolName = selectedTool.name

        let areaName
        let areaShortName

        selectedTool.areas.find(({ id, name, area: { id: areaId, shortName } }) => {
          if (areaId === area && id === tool) {
            areaName = name
            return areaShortName = shortName
          }
        })

        if (areaShortName) {
          return `${areaShortName} (${toolName})`
        }

        return `${toolName}`
      }
    }

    return ''
  }
})(FullToolsReport)
